webpackJsonp([1],{

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firebase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(289);





var Firebase = function Firebase() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Firebase);

    __WEBPACK_IMPORTED_MODULE_1_firebase__["initializeApp"](__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */]);
    return __WEBPACK_IMPORTED_MODULE_1_firebase__;
};

var firebase = new Firebase();

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(431)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(467),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middlewares_auth__ = __webpack_require__(291);



var middlewares = [__WEBPACK_IMPORTED_MODULE_0__middlewares_auth__["a" /* default */]];

/* harmony default export */ __webpack_exports__["a"] = (middlewares);

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(296);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    base: __dirname,
    routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        };
    }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  data: function data() {
    return {
      sum: 0,
      inProgress: false,
      message: '',
      snackbar: false
    };
  },

  methods: {
    fund: function fund() {
      var _this = this;

      console.log('fund', this.sum);
      this.inProgress = true;
      this.$store.dispatch("account/addBalance", this.sum).then(function (res) {
        console.log('success', res);
        _this.message = 'Баланс пополнен';
        _this.snackbar = true;
        _this.sum = 0;
        _this.inProgress = false;
      }).catch(function (err) {
        console.log('error', err);
        _this.message = 'Ошибка пополнения';
        _this.inProgress = false;
        _this.snackbar = true;
      });
    }
  }
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BalanceBox__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BalanceBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_BalanceBox__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    balancebox: __WEBPACK_IMPORTED_MODULE_0__partials_BalanceBox___default.a
  },
  created: function created() {},
  mounted: function mounted() {},

  computed: {
    transactions: function transactions() {
      return this.$store.state.account.transactions;
    }
  },
  data: function data() {
    return {
      headers: [{ text: 'Тип',
        align: 'left',
        sortable: false,
        value: 'type' }, { text: 'Дата',
        sortable: false,
        value: 'date' }, { text: 'Сумма',
        align: 'right',
        sortable: false,
        value: 'sum' }, { text: 'Комментарии',
        align: 'left',
        sortable: false,
        value: 'comment' }]
    };
  },

  methods: {
    withdraw: function withdraw() {
      console.log('withdraw');
    }
  }
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  created: function created() {},
  mounted: function mounted() {},

  computed: {},
  data: function data() {
    return {};
  },

  methods: {
    withdraw: function withdraw() {
      console.log('withdraw');
    }
  }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_Item__ = __webpack_require__(293);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.$auth.check().then(function (user) {}).catch(function (err) {
      console.log(err);
    });
  },
  firebase: function firebase() {
    var _this = this;

    return {
      data: {
        source: this.$myDatabase.child("item"),
        readyCallback: function readyCallback() {
          _this.ready = true;
        }
      }
    };
  },
  data: function data() {
    return {
      token: "",
      Item: new __WEBPACK_IMPORTED_MODULE_0__models_Item__["a" /* default */](this.$myDatabase.child('item')).init(),
      ready: false
    };
  },

  methods: {
    addItem: function addItem() {
      this.$firebaseRefs.data.onDisconnect().cancel();
      this.Item.push();
      this.Item.name = "";
    },
    deleteItem: function deleteItem(key) {
      this.Item.remove(key);
    }
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_Person__ = __webpack_require__(294);




/* harmony default export */ __webpack_exports__["default"] = ({
    created: function created() {
        var _this = this;

        this.$binding('Persons', this.$myFirestore.collection('Persons')).then(function (data) {
            _this.ready = true;
        });
    },
    data: function data() {
        return {
            Person: new __WEBPACK_IMPORTED_MODULE_0__models_Person__["a" /* default */](this.$myFirestore.collection('Persons')).init(),
            ready: false
        };
    },

    methods: {
        add: function add() {
            this.Person.add().then(function (success) {}).catch(function (error) {
                console.log(error.message);
            });
            this.Person.name = "";
        },
        remove: function remove(key) {
            this.Person.delete(key).then(function () {}).catch(function (error) {
                console.log(error.message);
            });
        }
    }
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_utils__ = __webpack_require__(297);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.$auth.check().then(function (user) {
      console.log('Layout mounted', user.email);
    }).catch(function (err) {});
  },
  data: function data() {
    return {
      drawer: false,
      RoutesUtils: __WEBPACK_IMPORTED_MODULE_0__router_utils__["a" /* default */].navigation
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      this.$auth.logout().then(function () {
        _this.$router.push('/login');
      });
    },
    login: function login() {
      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: ["id"],
  created: function created() {
    console.log('projectCard.created', this.id);
    var Pr = this.$store.getters["projects/projectByID"](this.id);
    this.Project = Pr;
  },
  mounted: function mounted() {},

  computed: {},
  data: function data() {
    return {
      Project: {},
      sum: 0,
      message: '',
      snackbar: false,
      rules: {
        required: function required(value) {
          return !!value || 'Обязательное поле.';
        },
        positive: function positive(v) {
          return v > 0 || 'Только положительное';
        },
        emailMatch: function emailMatch() {
          return 'The email and password you entered don\'t match';
        }
      }

    };
  },

  methods: {
    invest: function invest() {
      var _this = this;

      var max = this.$store.getters['account/account'].sum_balance;
      if (this.sum > max) {
        this.message = 'Для инвестирования не хватает суммы на балансе';
        this.snackbar = true;
        this.sum = max;
        return;
      }
      console.log('invest');
      this.$store.dispatch('projects/investToProject', { sum: this.sum, projectID: this.Project.id }).then(function (res) {
        console.log('investing complete', res);
        _this.$router.push({ name: 'Проекты' });
      });
    }
  }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BalanceBox__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BalanceBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_BalanceBox__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    balancebox: __WEBPACK_IMPORTED_MODULE_0__partials_BalanceBox___default.a
  },
  created: function created() {
    this.ready = true;
  },
  mounted: function mounted() {},

  computed: {
    Projects: function Projects() {
      return this.$store.getters['projects/projectsByStatus']('открыт');
    },
    myProjects: function myProjects() {
      return this.$store.getters['projects/myProjects'];
    }
  },
  data: function data() {
    return {
      ready: false,
      elems: [{ name: '1', quantity: 1 }],
      headers: [{ text: '№',
        align: 'left',
        sortable: false,
        value: 'name' }, { text: 'Статус',
        align: 'left',
        value: 'status' }, { text: 'Проект',
        align: 'left',
        sortable: false,
        value: 'name' }, { text: 'Сумма',
        align: 'right',
        value: 'sumMy' }, { text: 'Профит',
        align: 'right',
        value: 'profit' }]
    };
  },

  methods: {
    invest: function invest(id) {
      console.log('invest', id);
      this.$router.push({ name: 'Проект', params: { id: id } });
    },
    clickProject: function clickProject(item) {
      console.log('click', item.num);
      this.$router.push({ name: 'Проект', params: { id: item.id } });
    }
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {},
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    this.$auth.logout();
    this.$auth.state("/projects-list", "/login").then(function (user) {
      if (!user) {
        _this.ready = false;
      }
    });
  },
  data: function data() {
    return {
      snackbar: false,
      email: "",
      password: "",
      error: "",
      ready: false,
      emailRules: [function (v) {
        return !!v || "E-mail обязателен";
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail некорректен"
        );
      }],
      e3: true
    };
  },

  computed: {},
  methods: {
    login: function login() {
      var _this2 = this;

      this.ready = true;
      this.$auth.logout();
      this.$store.dispatch('auth/login', {
        email: this.email,
        password: this.password
      }).then(function (user) {
        _this2.ready = false;
      }).catch(function (error) {
        console.log('error in login', error.message);

        _this2.snackbar = true;
        _this2.ready = false;
        _this2.error = error.message;
      });
    },
    register: function register() {
      var _this3 = this;

      this.ready = true;
      this.$store.dispatch('auth/register', {
        email: this.email,
        password: this.password
      }).then(function (user) {
        _this3.ready = false;
      }).catch(function (error) {
        _this3.error = error.message;
        _this3.ready = false;
        _this3.snackbar = true;
      });
    },
    signInGoogle: function signInGoogle() {
      var _this4 = this;

      this.ready = true;
      this.$auth.signInWithGoogle().then(function (result) {
        _this4.ready = false;
      }).catch(function (error) {
        _this4.error = error.message;
        _this4.ready = false;
        _this4.snackbar = true;
      });
    },
    signInFacebook: function signInFacebook() {
      var _this5 = this;

      this.ready = true;
      this.$auth.signInWithFacebook().then(function (result) {
        _this5.ready = false;
      }).catch(function (error) {
        _this5.error = error.message;
        _this5.ready = false;
        _this5.snackbar = true;
      });
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_Profile__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(259);


var _this2 = this;




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    console.log('UpdateProfile.mounting');

    this.$auth.check().then(function (user) {
      _this.ready = false;
    });
  },
  data: function data() {
    return {
      message: '',
      selectedPhoto: { name: '' },
      error: '',
      snackbar: false,
      ready: true,
      emailRules: [function (v) {
        return !!v || "E-mail обязателен";
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail некорректен"
        );
      }],
      rules: {
        required: function required(value) {
          return !!value || 'Обязательное поле.';
        },
        min: function min(v) {
          return v.length >= 8 || 'Min 8 characters';
        },
        emailMatch: function emailMatch() {
          return 'The email and password you entered don\'t match';
        }
      }
    };
  },

  watch: {
    '$store.state.auth.profileReady': function $storeStateAuthProfileReady() {
      console.log('watch profile ');
      _this2.ready = false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('auth', { Profile: function Profile(state) {
      return state.profile;
    } })),
  methods: {
    getFile: function getFile(e) {
      this.selectedPhoto = e.target.files[0];
    },
    updateAvatar: function updateAvatar() {
      var _this3 = this;

      if (!this.selectedPhoto) {
        return;
      }
      this.ready = true;
      var name = this.Profile.uid;
      this.$storage.upload({
        ref: '/images/' + name,
        file: this.selectedPhoto,
        progress: function progress(snapshot) {},
        error: function error(err) {
          _this3.message = err.message;
          _this3.snackbar = true;
        },
        completed: function completed(downloadURL) {
          _this3.updateProfilePicture(downloadURL).then(function () {
            _this3.message = 'Ваш аватар обновлен';
            _this3.snackbar = true;
            _this3.selectedPhoto = { name: "" };
            _this3.ready = false;
          }).catch(function (error) {
            _this3.message = error.message;
            _this3.snackbar = true;
          });
        }
      });
    },
    updateProfilePicture: function updateProfilePicture(fileName) {

      this.Profile.photoURL = fileName;
      return this.$auth.updateProfilePicture(fileName);
    },
    updateProfile: function updateProfile() {
      var _this4 = this;

      this.ready = true;
      this.$store.dispatch('auth/saveProfile', this.Profile).then(function () {
        _this4.message = 'Ваш профиль обновлен';
        _this4.snackbar = true;
        _this4.ready = false;
      }).catch(function (error) {
        _this4.message = error.message;
        _this4.snackbar = true;
        _this4.ready = false;
      });
    },
    synchronize: function synchronize() {}
  }
});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {},
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {},
    created: function created() {},
    mounted: function mounted() {},

    computed: {},
    data: function data() {
        return {};
    },

    methods: {}
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},
  mounted: function mounted() {},

  computed: {
    Account: function Account() {
      return this.$store.state.account.account;
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    fund: function fund(id) {
      console.log('fund', id);
      this.$router.push('/fund-account');
    },
    withdraw: function withdraw(id) {
      console.log('withdraw', id);
      this.$router.push('/withdraw-account');
    }
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var config = {
    apiKey: "AIzaSyCva2SQZbcyXQbf9vlHmbpJBk77AikgoB4",
    authDomain: "fuelcrowd19.firebaseapp.com",
    databaseURL: "https://fuelcrowd19.firebaseio.com",
    projectId: "fuelcrowd19",
    storageBucket: "gs://fuelcrowd19.appspot.com/",
    messagingSenderId: "526950178741",
    appId: "1:526950178741:web:cc8d42ec08c1809e"
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__storage_store__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_myfirebase__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_myfirebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_myfirebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_firestore__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__firebase_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middlewares_index__ = __webpack_require__(260);

__webpack_require__(262);










console.log("Init 0");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuetify___default.a);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_firestore___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_myfirebase___default.a, {
    store: __WEBPACK_IMPORTED_MODULE_2__storage_store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
    middlewares: __WEBPACK_IMPORTED_MODULE_7__middlewares_index__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_6__firebase_firebase__["a" /* firebase */].auth().onAuthStateChanged(function (user) {
    if (user) {
        console.log('signed', user.email, user.uid, user.photoUrl);
        __WEBPACK_IMPORTED_MODULE_2__storage_store__["a" /* default */].commit('auth/setUid', user.uid);
        __WEBPACK_IMPORTED_MODULE_2__storage_store__["a" /* default */].dispatch('auth/loadProfile', user).then(function () {
            __WEBPACK_IMPORTED_MODULE_2__storage_store__["a" /* default */].dispatch('account/fetchAccount', user);
            __WEBPACK_IMPORTED_MODULE_2__storage_store__["a" /* default */].dispatch('projects/fetchProjects');
        });
    } else {
        console.log('signed out');
    }
});
var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_2__storage_store__["a" /* default */],
    mounted: function mounted() {
        var env = "production";
    },
    data: function data() {
        return {};
    }
}).$mount('#app');

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var AuthMiddleware = function AuthMiddleware(myfirebase, actions) {
  if (actions.to.matched.some(function (record) {
    return record.meta.auth;
  })) {
    myfirebase.auth.check().then(function (user) {
      actions.next();
    }).catch(function (err) {
      actions.next({ path: '/login' });
    });
  } else {
    actions.next();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (AuthMiddleware);

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Account = function Account(ref) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Account);

  this.id = ref.id || '';
  this.sum_balance = ref.sum_balance || 0;
  this.sum_locked = ref.sum_locked || 0;
  this.sum_invested = ref.sum_invested || 0;
  this.profit = ref.profit || 0;
  this.num = ref.num || '';
};

/* harmony default export */ __webpack_exports__["a"] = (Account);

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_myfirebase__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_myfirebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_myfirebase__);







var Item = function (_DatabaseModel) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Item, _DatabaseModel);

    function Item(ref) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Item);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Item.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Item)).call(this, ref));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Item, [{
        key: 'required',
        value: function required() {
            return [];
        }
    }]);

    return Item;
}(__WEBPACK_IMPORTED_MODULE_5_myfirebase__["DatabaseModel"]);

/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_myfirebase__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_myfirebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_myfirebase__);







var Person = function (_FirestoreModel) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Person, _FirestoreModel);

    function Person(ref) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Person);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Person.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Person)).call(this, ref));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Person, [{
        key: 'required',
        value: function required() {
            return [];
        }
    }]);

    return Person;
}(__WEBPACK_IMPORTED_MODULE_5_myfirebase__["FirestoreModel"]);

/* harmony default export */ __webpack_exports__["a"] = (Person);

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var Moment = __webpack_require__(0);

var Project = function () {
    function Project(ref) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Project);

        this.id = ref.id;
        this.status = ref.status || "открыт";
        this.name = ref.name || "--";
        this.num = ref.num || '';
        this.quantity = ref.quantity || 0;
        this.maxQuantity = ref.maxQuantity || 0;
        this.sum = ref.sum || 0;
        this.maxSum = ref.maxSum || 0;
        this.profitExpected = ref.profitExpected || 0;
        this.my = false;
        this.sumMy = 0;
        this.displayName = ref.displayName || "";
        this.active = ref.active || false;

        var d = new Moment(ref.dateStart.toDate() || '');
        this.dateStart = d.format('DD.MM.YY') || '';
        if (ref.dateExpected) {
            this.dateExpected = new Moment(ref.dateExpected.toDate()).format('DD.MM.YY');
        } else {
            this.dateExpected = '';
        }
        if (ref.dateFinish) {
            this.dateFinish = new Moment(ref.dateFinish.toDate()).format('DD.MM.YY');
        } else {
            this.dateFinish = '';
        }

        this.myInvestments = [];
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Project, [{
        key: "required",
        value: function required() {
            return [];
        }
    }]);

    return Project;
}();

/* harmony default export */ __webpack_exports__["a"] = (Project);

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layout__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Welcome__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_Login__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_auth_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_UpdateProfile__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_UpdateProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_auth_UpdateProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_App__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_errors_404__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_errors_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_errors_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Firestore__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ProjectsList__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ProjectsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ProjectsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ProjectCard__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ProjectCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ProjectCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountFund__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountFund___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_AccountFund__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccountWithdraw__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccountWithdraw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_AccountWithdraw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AccountHistory__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AccountHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_AccountHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_faq__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_faq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_faq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__(32);
















var routes = [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_0__components_Layout___default.a,
    children: [{
        path: '/',
        component: __WEBPACK_IMPORTED_MODULE_1__components_Welcome___default.a,
        name: 'Главная'
    }, {
        path: '/login',
        component: __WEBPACK_IMPORTED_MODULE_2__components_auth_Login___default.a,
        name: 'login'
    }, {
        path: '/update-profile',
        component: __WEBPACK_IMPORTED_MODULE_3__components_auth_UpdateProfile___default.a,
        name: 'Профиль',
        meta: {
            auth: true
        }
    }, {
        path: '/account',
        component: __WEBPACK_IMPORTED_MODULE_11__components_AccountHistory___default.a,
        name: 'История счета',
        meta: {
            auth: true
        }
    }, {
        path: '/fund-account',
        component: __WEBPACK_IMPORTED_MODULE_9__components_AccountFund___default.a,
        name: 'Пополнение счета',
        meta: {
            auth: true
        }
    }, {
        path: '/withdraw-account',
        component: __WEBPACK_IMPORTED_MODULE_10__components_AccountWithdraw___default.a,
        name: 'Вывод средств',
        meta: {
            auth: true
        }
    }, {
        path: '/projects-list',
        component: __WEBPACK_IMPORTED_MODULE_7__components_ProjectsList___default.a,
        name: 'Проекты',
        meta: {
            auth: true
        }
    }, {
        path: '/project/:id',
        component: __WEBPACK_IMPORTED_MODULE_8__components_ProjectCard___default.a,
        name: 'Проект',
        props: true,
        meta: {
            auth: true
        }
    }, {
        path: '/faq',
        component: __WEBPACK_IMPORTED_MODULE_12__components_faq___default.a,
        name: 'Вопросы и ответы',
        meta: {
            auth: false
        }
    }, {
        path: '/firestore',
        component: __WEBPACK_IMPORTED_MODULE_6__components_Firestore___default.a,
        name: 'Cloud Firestore',
        meta: {
            auth: true
        }
    }, {
        path: '*',
        component: __WEBPACK_IMPORTED_MODULE_5__components_errors_404___default.a
    }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var UTILS = {
  navigation: {
    docs: function docs() {
      window.location.replace("https://myfirebase.github.io");
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (UTILS);

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Account__ = __webpack_require__(292);





var Moment = __webpack_require__(0);

var state = {
  account: {},
  investments: [],
  transactions: []
};
var getters = {
  account: function account(state) {
    return state.account;
  },
  transactions: function transactions(state) {
    return state.transactions.slice(0, 20);
  }
};
var mutations = {
  setAccount: function setAccount(state, value) {
    state.account = value;
  },
  setTransactions: function setTransactions(state, value) {
    state.transactions = value;
  }
};
var actions = {
  fetchAccount: function fetchAccount(_ref) {
    var _this = this;

    var state = _ref.state,
        commit = _ref.commit,
        rootState = _ref.rootState,
        rootGetters = _ref.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__["a" /* firebase */].firestore().collection("Account").doc(rootState.auth.uid).onSnapshot(function (docdata) {
                if (docdata.exists) {
                  var fbdata = new __WEBPACK_IMPORTED_MODULE_3__models_Account__["a" /* default */](docdata.data());
                } else {
                  var fbdata = new __WEBPACK_IMPORTED_MODULE_3__models_Account__["a" /* default */]({});
                }
                fbdata.id = rootState.auth.uid;
                commit("setAccount", fbdata);
              });

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__["a" /* firebase */].firestore().collection("Transactions").where("userID", "==", rootState.auth.uid).orderBy("date", "desc").onSnapshot(function (docdata) {
                var arr = [];
                docdata.forEach(function (doc) {
                  var elem = doc.data();
                  var d = new Moment(elem.date.toDate() || '');
                  elem.date = d.format('DD.MM.YY hh:mm') || '';
                  elem.id = doc.id;
                  arr.push(elem);
                });


                commit("setTransactions", arr);
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  addBalance: function addBalance(_ref2, sum) {
    var _this2 = this;

    var state = _ref2.state,
        rootState = _ref2.rootState;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var fnc;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('store.account.addBalance:', rootState.auth.uid, sum);
              fnc = __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__["a" /* firebase */].functions().httpsCallable('addBalance');
              return _context2.abrupt("return", fnc({ sum: Number(sum), userID: rootState.auth.uid, type: 'Пополнение счета' }).then(function (result) {
                console.log('transaction result', result.data);
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};
var storeConf = {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  namespaced: true
};
/* harmony default export */ __webpack_exports__["a"] = (storeConf);

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Profile__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(91);






var auth = __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__["a" /* firebase */].auth();

var error = '';

var googleAuthProvider = new __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__["a" /* firebase */].auth.GoogleAuthProvider();

var facebookAuthProvider = new __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__["a" /* firebase */].auth.FacebookAuthProvider();

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    auth: auth,
    uid: '',
    profile: new __WEBPACK_IMPORTED_MODULE_3__models_Profile__["a" /* default */]({}),
    profileReady: false,
    error: error,
    googleAuthProvider: googleAuthProvider,
    facebookAuthProvider: facebookAuthProvider
  },
  mutations: {
    setUid: function setUid(state, data) {
      state.uid = data;
    },
    setProfile: function setProfile(state, data) {
      state.profile = data;
    },
    setProfileReady: function setProfileReady(state, data) {
      state.profileReady = data;
    }
  },
  getters: {
    uid: function uid(state) {
      return state.uid;
    }
  },
  actions: {
    login: function login(context, user) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('logining', user);
                return _context.abrupt('return', context.state.auth.signInWithEmailAndPassword(user.email, user.password).then(function (usr) {
                  console.log('login success', usr.uid, usr);
                  context.commit('setUid', usr.uid);
                  context.dispatch('loadProfile', usr);
                }));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadProfile: function loadProfile(context, user) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('loading profile', context.state.uid, user.email);
                if (context.state.uid) {
                  __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__["a" /* firebase */].firestore().collection("Profiles").doc(context.state.uid).get().then(function (doc) {
                    var p = void 0;
                    if (doc.exists) {
                      console.log('есть Profile');
                      p = new __WEBPACK_IMPORTED_MODULE_3__models_Profile__["a" /* default */](doc.data());
                    } else {
                      console.log('no Profile');
                      p = new __WEBPACK_IMPORTED_MODULE_3__models_Profile__["a" /* default */]({});
                    }
                    p.displayName = user.displayName;
                    p.uid = user.uid;
                    p.email = user.email;
                    p.photoURL = user.photoURL || '';
                    context.commit('setProfile', p);
                    context.commit('setProfileReady', true);
                  });
                }

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    logout: function logout(context) {
      console.log('loggin out', context.state.uid);

      context.commit('setUid', '');
      context.commit('setProfileReady', false);

      return context.state.auth.signOut();
    },
    register: function register(context, user) {
      return context.state.auth.createUserWithEmailAndPassword(user.email, user.password);
    },
    signInGoogle: function signInGoogle(context) {
      var provider = context.state.googleAuthProvider;
      return context.state.auth.signInWithPopup(provider);
    },
    signInFacebook: function signInFacebook(context) {
      var provider = context.state.facebookAuthProvider;
      return context.state.auth.signInWithPopup(provider);
    },
    updateProfilePicture: function updateProfilePicture(context, image) {
      return context.state.auth.currentUser.updateProfile({
        photoURL: image
      });
    },
    saveProfile: function saveProfile(context, newProfile) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var p;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                p = {
                  FIO: newProfile.FIO,
                  phone: newProfile.phone,
                  city: newProfile.city,
                  role: newProfile.role,
                  passport: newProfile.passport,
                  address: newProfile.address
                };
                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__["a" /* firebase */].firestore().collection("Profiles").doc(context.state.uid).update(p).then(function (doc) {
                  console.log('profile saved');
                  context.commit('setProfile', newProfile);
                  return context.state.auth.currentUser.updateProfile({
                    displayName: p.FIO
                  });
                }));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__ = __webpack_require__(25);


var storage = __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__["a" /* firebase */].storage();

var error = '';

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        storage: storage,
        error: error
    },
    mutations: {
        uploadFile: function uploadFile(state, file) {
            var task = state.storage.ref().child(file.ref).put(file.file);
            task.on('state_changed', function progress(snapshot) {
                file.progress(snapshot);
            }, function error(err) {
                file.error(err);
            }, function completed() {
                task.snapshot.ref.getDownloadURL().then(function (url) {
                    file.completed(url);
                });
            });
        },
        uploadFiles: function uploadFiles(state, files) {
            for (var key in files.files) {
                if (files.files.hasOwnProperty(key)) {
                    var task = state.storage.ref().child(files.ref + '/' + files.files[key].name).put(files.files[key]);
                    task.on('state_changed', function progress(snapshot) {
                        files.progress(snapshot);
                    }, function error(err) {
                        files.error(err);
                    }, function completed() {
                        files.completed();
                    });
                }
            }
        }
    },
    actions: {
        deleteFile: function deleteFile(context, file) {
            return context.state.storage.ref().child(file).delete();
        }
    },
    getters: {}
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Project__ = __webpack_require__(295);





var state = {
  projects: []
};
var getters = {
  projects: function projects(state) {
    return state.projects;
  },
  projectByID: function projectByID(state) {
    return function (id) {
      var res = state.projects.find(function (elem) {
        return elem.id === id;
      });
      if (!res) {
        res = new __WEBPACK_IMPORTED_MODULE_3__models_Project__["a" /* default */]({});
      }
      return res;
    };
  },
  projectsByStatus: function projectsByStatus(state) {
    return function (status) {
      return state.projects.filter(function (elem) {
        return elem.status === status;
      });
    };
  },
  myProjects: function myProjects(state) {
    return state.projects.filter(function (elem) {
      return elem.my === true;
    });
  }
};
var mutations = {
  setProjects: function setProjects(state, value) {
    state.projects = value;
  }
};
var actions = {
  fetchProjects: function fetchProjects(_ref) {
    var _this = this;

    var state = _ref.state,
        commit = _ref.commit,
        rootGetters = _ref.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('store.projects.fetchProjects ', rootGetters["auth/uid"]);
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__["a" /* firebase */].firestore().collection("Projects").where("active", "==", true).onSnapshot(function (docdata) {
                var arr = [];
                docdata.forEach(function (doc) {
                  var elem = new __WEBPACK_IMPORTED_MODULE_3__models_Project__["a" /* default */](doc.data());
                  elem.id = doc.id;


                  if (doc.data().investments) {
                    elem.myInvestments = doc.data().investments.filter(function (elem) {
                      return elem.userID === rootGetters["auth/uid"];
                    });
                    elem.my = elem.myInvestments.length > 0;
                    elem.sumMy = elem.myInvestments.reduce(function (total, p) {
                      return total + p.sum;
                    }, 0);
                  }
                  arr.push(elem);
                });
                commit("setProjects", arr);
              });

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  investToProject: function investToProject(_ref2, params) {
    var _this2 = this;

    var state = _ref2.state,
        commit = _ref2.commit,
        rootState = _ref2.rootState;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var fnc;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('store.account.investToProject:', rootState.auth.uid, params);
              fnc = __WEBPACK_IMPORTED_MODULE_2__firebase_firebase__["a" /* firebase */].functions().httpsCallable('makeInvest');
              _context2.next = 4;
              return fnc({ sum: Number(params.sum), userID: rootState.auth.uid, projectID: params.projectID }).then(function (result) {
                console.log('transaction result', result.data);
              });

            case 4:
              return _context2.abrupt('return', _context2.sent);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};
var storeConf = {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  namespaced: true
};
/* harmony default export */ __webpack_exports__["a"] = (storeConf);

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 129,
	"./af.js": 129,
	"./ar": 136,
	"./ar-dz": 130,
	"./ar-dz.js": 130,
	"./ar-kw": 131,
	"./ar-kw.js": 131,
	"./ar-ly": 132,
	"./ar-ly.js": 132,
	"./ar-ma": 133,
	"./ar-ma.js": 133,
	"./ar-sa": 134,
	"./ar-sa.js": 134,
	"./ar-tn": 135,
	"./ar-tn.js": 135,
	"./ar.js": 136,
	"./az": 137,
	"./az.js": 137,
	"./be": 138,
	"./be.js": 138,
	"./bg": 139,
	"./bg.js": 139,
	"./bm": 140,
	"./bm.js": 140,
	"./bn": 141,
	"./bn.js": 141,
	"./bo": 142,
	"./bo.js": 142,
	"./br": 143,
	"./br.js": 143,
	"./bs": 144,
	"./bs.js": 144,
	"./ca": 145,
	"./ca.js": 145,
	"./cs": 146,
	"./cs.js": 146,
	"./cv": 147,
	"./cv.js": 147,
	"./cy": 148,
	"./cy.js": 148,
	"./da": 149,
	"./da.js": 149,
	"./de": 152,
	"./de-at": 150,
	"./de-at.js": 150,
	"./de-ch": 151,
	"./de-ch.js": 151,
	"./de.js": 152,
	"./dv": 153,
	"./dv.js": 153,
	"./el": 154,
	"./el.js": 154,
	"./en-SG": 155,
	"./en-SG.js": 155,
	"./en-au": 156,
	"./en-au.js": 156,
	"./en-ca": 157,
	"./en-ca.js": 157,
	"./en-gb": 158,
	"./en-gb.js": 158,
	"./en-ie": 159,
	"./en-ie.js": 159,
	"./en-il": 160,
	"./en-il.js": 160,
	"./en-nz": 161,
	"./en-nz.js": 161,
	"./eo": 162,
	"./eo.js": 162,
	"./es": 165,
	"./es-do": 163,
	"./es-do.js": 163,
	"./es-us": 164,
	"./es-us.js": 164,
	"./es.js": 165,
	"./et": 166,
	"./et.js": 166,
	"./eu": 167,
	"./eu.js": 167,
	"./fa": 168,
	"./fa.js": 168,
	"./fi": 169,
	"./fi.js": 169,
	"./fo": 170,
	"./fo.js": 170,
	"./fr": 173,
	"./fr-ca": 171,
	"./fr-ca.js": 171,
	"./fr-ch": 172,
	"./fr-ch.js": 172,
	"./fr.js": 173,
	"./fy": 174,
	"./fy.js": 174,
	"./ga": 175,
	"./ga.js": 175,
	"./gd": 176,
	"./gd.js": 176,
	"./gl": 177,
	"./gl.js": 177,
	"./gom-latn": 178,
	"./gom-latn.js": 178,
	"./gu": 179,
	"./gu.js": 179,
	"./he": 180,
	"./he.js": 180,
	"./hi": 181,
	"./hi.js": 181,
	"./hr": 182,
	"./hr.js": 182,
	"./hu": 183,
	"./hu.js": 183,
	"./hy-am": 184,
	"./hy-am.js": 184,
	"./id": 185,
	"./id.js": 185,
	"./is": 186,
	"./is.js": 186,
	"./it": 188,
	"./it-ch": 187,
	"./it-ch.js": 187,
	"./it.js": 188,
	"./ja": 189,
	"./ja.js": 189,
	"./jv": 190,
	"./jv.js": 190,
	"./ka": 191,
	"./ka.js": 191,
	"./kk": 192,
	"./kk.js": 192,
	"./km": 193,
	"./km.js": 193,
	"./kn": 194,
	"./kn.js": 194,
	"./ko": 195,
	"./ko.js": 195,
	"./ku": 196,
	"./ku.js": 196,
	"./ky": 197,
	"./ky.js": 197,
	"./lb": 198,
	"./lb.js": 198,
	"./lo": 199,
	"./lo.js": 199,
	"./lt": 200,
	"./lt.js": 200,
	"./lv": 201,
	"./lv.js": 201,
	"./me": 202,
	"./me.js": 202,
	"./mi": 203,
	"./mi.js": 203,
	"./mk": 204,
	"./mk.js": 204,
	"./ml": 205,
	"./ml.js": 205,
	"./mn": 206,
	"./mn.js": 206,
	"./mr": 207,
	"./mr.js": 207,
	"./ms": 209,
	"./ms-my": 208,
	"./ms-my.js": 208,
	"./ms.js": 209,
	"./mt": 210,
	"./mt.js": 210,
	"./my": 211,
	"./my.js": 211,
	"./nb": 212,
	"./nb.js": 212,
	"./ne": 213,
	"./ne.js": 213,
	"./nl": 215,
	"./nl-be": 214,
	"./nl-be.js": 214,
	"./nl.js": 215,
	"./nn": 216,
	"./nn.js": 216,
	"./pa-in": 217,
	"./pa-in.js": 217,
	"./pl": 218,
	"./pl.js": 218,
	"./pt": 220,
	"./pt-br": 219,
	"./pt-br.js": 219,
	"./pt.js": 220,
	"./ro": 221,
	"./ro.js": 221,
	"./ru": 222,
	"./ru.js": 222,
	"./sd": 223,
	"./sd.js": 223,
	"./se": 224,
	"./se.js": 224,
	"./si": 225,
	"./si.js": 225,
	"./sk": 226,
	"./sk.js": 226,
	"./sl": 227,
	"./sl.js": 227,
	"./sq": 228,
	"./sq.js": 228,
	"./sr": 230,
	"./sr-cyrl": 229,
	"./sr-cyrl.js": 229,
	"./sr.js": 230,
	"./ss": 231,
	"./ss.js": 231,
	"./sv": 232,
	"./sv.js": 232,
	"./sw": 233,
	"./sw.js": 233,
	"./ta": 234,
	"./ta.js": 234,
	"./te": 235,
	"./te.js": 235,
	"./tet": 236,
	"./tet.js": 236,
	"./tg": 237,
	"./tg.js": 237,
	"./th": 238,
	"./th.js": 238,
	"./tl-ph": 239,
	"./tl-ph.js": 239,
	"./tlh": 240,
	"./tlh.js": 240,
	"./tr": 241,
	"./tr.js": 241,
	"./tzl": 242,
	"./tzl.js": 242,
	"./tzm": 244,
	"./tzm-latn": 243,
	"./tzm-latn.js": 243,
	"./tzm.js": 244,
	"./ug-cn": 245,
	"./ug-cn.js": 245,
	"./uk": 246,
	"./uk.js": 246,
	"./ur": 247,
	"./ur.js": 247,
	"./uz": 249,
	"./uz-latn": 248,
	"./uz-latn.js": 248,
	"./uz.js": 249,
	"./vi": 250,
	"./vi.js": 250,
	"./x-pseudo": 251,
	"./x-pseudo.js": 251,
	"./yo": 252,
	"./yo.js": 252,
	"./zh-cn": 253,
	"./zh-cn.js": 253,
	"./zh-hk": 254,
	"./zh-hk.js": 254,
	"./zh-tw": 255,
	"./zh-tw.js": 255
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 439;

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0MDAgNDAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgNDAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojMzFCRkVGO30NCgkuc3Qxe2ZpbGw6IzE3MjY0RTt9DQoJLnN0MntmaWxsOiNGQkUwMEI7fQ0KPC9zdHlsZT4NCjxnIGlkPSJYTUxJRF84XyI+DQoJPHBhdGggaWQ9IlhNTElEXzEzXyIgY2xhc3M9InN0MCIgZD0iTTExMy45LDI0Mi4xTDExMy45LDI0Mi4xYy0yMi40LTI3LjYtMTguMi02OCw5LjQtOTAuNGwxNDgtMTIwLjFsMCwwDQoJCWMyMi40LDI3LjYsMTguMiw2OC05LjQsOTAuNEwxMTMuOSwyNDIuMXoiLz4NCgk8cGF0aCBpZD0iWE1MSURfMTBfIiBjbGFzcz0ic3QxIiBkPSJNMTYxLjcsMzAxLjFMMTYxLjcsMzAxLjFjLTIyLjQtMjcuNi0xOC4yLTY4LDkuNC05MC40bDEwNC42LTg0LjhsMCwwDQoJCWMyMi40LDI3LjYsMTguMiw2OC05LjQsOTAuNEwxNjEuNywzMDEuMXoiLz4NCgk8cGF0aCBpZD0iWE1MSURfOV8iIGNsYXNzPSJzdDIiIGQ9Ik0yMDkuNSwzNjBMMjA5LjUsMzYwYy0yMi40LTI3LjYtMTguMi02OCw5LjQtOTAuNGwzOC41LTMxLjJsMCwwYzIyLjQsMjcuNiwxOC4yLDY4LTkuNCw5MC40DQoJCUwyMDkuNSwzNjB6Ii8+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(426)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(462),
  /* scopeId */
  "data-v-2db5e9f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(427)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(463),
  /* scopeId */
  "data-v-33eda91a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(432)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(468),
  /* scopeId */
  "data-v-9848198a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(435)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(471),
  /* scopeId */
  "data-v-f5ad63f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(428)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(464),
  /* scopeId */
  "data-v-3db88a4f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(423)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(459),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(433)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(469),
  /* scopeId */
  "data-v-d6078ca6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(434)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(470),
  /* scopeId */
  "data-v-d9bd1af8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(425)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(461),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(422)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(458),
  /* scopeId */
  "data-v-03d95b64",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(429)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(465),
  /* scopeId */
  "data-v-569211f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(430)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(466),
  /* scopeId */
  "data-v-5be5edc0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(460),
  /* scopeId */
  "data-v-10e5449a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 458:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-auto"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Авторизация")])])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.emailRules,
      "label": "E-mail",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": _vm.e3 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.e3 = !_vm.e3); },
      "type": _vm.e3 ? 'password' : 'text',
      "name": "input-10-2",
      "label": "Пароль",
      "hint": "Минимум 6 знаков",
      "min": "8",
      "value": "",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n              Войти\n            ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.register
    }
  }, [_vm._v("\n              Зарегистрироваться\n            ")])], 1), _vm._v(" "), (false) ? _c('v-btn', {
    staticClass: "google",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.signInGoogle
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
    }
  }), _vm._v("\n            Войти через Google\n          ")]) : _vm._e(), _vm._v(" "), (false) ? _c('v-btn', {
    staticClass: "facebook",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.signInFacebook
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg"
    }
  }), _vm._v("\n            Войти через Facebook\n          ")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "top": true,
      "bottom": false,
      "right": false,
      "left": false,
      "multi-line": false,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.error) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(_vm.$auth.user()) ? _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "disable-resize-watcher": "true",
      "temporary": "true",
      "hide-overlay": "",
      "width": "200"
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "transparent",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$auth.user().displayName || _vm.$auth.user().email))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/projects-list')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Проекты")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/account')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Лицевой счет")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/update-profile')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Профиль")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/faq')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Вопросы и ответы")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Выйти")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "app": ""
    }
  }, [(_vm.$auth.user()) ? _c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Fuelcrowd")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [(_vm.$auth.user()) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Выйти")]) : _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("Войти")])], 1)], 1), _vm._v(" "), _c('v-content', [_c('v-container', [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "app": ""
    }
  }, [_c('span', {
    staticClass: "text-center"
  }, [_vm._v("FuelCrowd © 2019")]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "justify-start": ""
    }
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Проекты'
      }
    }
  }, [_vm._v("Проекты")])], 1), _vm._v(" "), _c('span', [_vm._v("/"), _c('b', [_vm._v(" Вопросы и ответы ")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('h2', [_vm._v(" Частые вопросы и ответы ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "myflex",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('img', {
    staticClass: "logoimg",
    attrs: {
      "src": __webpack_require__(444),
      "alt": "MyfirebaseLogo"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('p', {
    staticClass: "display-1 font-weight-thin"
  }, [_vm._v("Добро пожаловать на платформу для инвестирования в реальный бизнес\n      ")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "justify-start": ""
    }
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Проекты'
      }
    }
  }, [_vm._v("Проекты")])], 1), _vm._v(" "), _c('span', [_vm._v("/"), _c('b', [_vm._v(" Пополнение счета ")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('h2', [_vm._v(" Реквизиты для пополнения счета ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12 md9"
  }, [_c('v-card', {
    staticClass: "elevation-1"
  }, [_c('v-card-title', [_c('h4', [_vm._v("Реквизиты")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Получатель:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v("ООО \"Организация\"")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("ИНН:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v("565845384529")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("БИК:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v("38473847")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Банк:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v("филиал Сбербанка г.Оренбург")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("р/с:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v("2342342734676722")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Назначение платежа:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v("Пополнение лицевого счета №"), _c('b', [_vm._v("182878")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 md8",
    attrs: {
      "my-4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-1"
  }, [_c('v-card-title', [_c('h4', [_vm._v("тест")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Сумма",
      "type": "number",
      "required": ""
    },
    model: {
      value: (_vm.sum),
      callback: function($$v) {
        _vm.sum = $$v
      },
      expression: "sum"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.fund()
      }
    }
  }, [_vm._v("Пополнить")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "top": true,
      "bottom": false,
      "right": true,
      "left": false,
      "multi-line": false,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Закрыть")])], 1), _vm._v(" "), (_vm.inProgress) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "justify-start": ""
    }
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Проекты'
      }
    }
  }, [_vm._v("Проекты")])], 1), _vm._v(" "), _c('span', [_vm._v("/"), _c('b', [_vm._v(" История счета ")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('balancebox', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-5": ""
    }
  }, [_c('div')]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("Транзакции")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.transactions,
      "hide-actions": "",
      "item-key": "date"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.date))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.sum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.comment))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Persons")]), _vm._v(" "), _vm._l((_vm.Persons), function(person, index) {
    return _c('v-list-tile', {
      key: index
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(person.name))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "black"
      },
      on: {
        "click": function($event) {
          return _vm.remove(person['.key'])
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-container', [_c('v-text-field', {
    attrs: {
      "label": "Person Name"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.add()
      }
    },
    model: {
      value: (_vm.Person.name),
      callback: function($$v) {
        _vm.$set(_vm.Person, "name", $$v)
      },
      expression: "Person.name"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("Add Person")])], 1)], 1), _vm._v(" "), (!_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ФИО",
      "required": ""
    },
    model: {
      value: (_vm.Profile.FIO),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "FIO", $$v)
      },
      expression: "Profile.FIO"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required],
      "label": "Телефон"
    },
    model: {
      value: (_vm.Profile.phone),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "phone", $$v)
      },
      expression: "Profile.phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "readonly": ""
    },
    model: {
      value: (_vm.Profile.email),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "email", $$v)
      },
      expression: "Profile.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Город"
    },
    model: {
      value: (_vm.Profile.city),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "city", $$v)
      },
      expression: "Profile.city"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Адрес"
    },
    model: {
      value: (_vm.Profile.address),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "address", $$v)
      },
      expression: "Profile.address"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Данные паспорта"
    },
    model: {
      value: (_vm.Profile.passport),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "passport", $$v)
      },
      expression: "Profile.passport"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "orange"
    },
    on: {
      "click": function($event) {
        return _vm.updateProfile()
      }
    }
  }, [_vm._v("Обновить данные")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "top": true,
      "bottom": false,
      "right": true,
      "left": false,
      "multi-line": false,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Закрыть")])], 1), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Страница не найдена")]), _vm._v(" "), _c('p', [_vm._v("Проверьте URL")]), _vm._v(" "), _c('h2')])
}]}

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('h2', [_vm._v("Баланс")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('span', [_vm._v("ЛС " + _vm._s(_vm.Account.num) + "  ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'История счета'
      },
      "text-right": ""
    }
  }, [_vm._v("История операций")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "elevation-1 my-2"
  }, [_c('v-layout', {
    attrs: {
      "justify-start": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(_vm._s(_vm.Account.sum_balance) + " р.")]), _vm._v(" "), _c('div', {
    staticClass: "labelsum"
  }, [_vm._v("свободно")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(_vm._s(_vm.Account.sum_invested) + " р.")]), _vm._v(" "), _c('div', {
    staticClass: "labelsum"
  }, [_vm._v("инвестировано")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(_vm._s(_vm.Account.sum_locked) + " р.")]), _vm._v(" "), _c('div', {
    staticClass: "labelsum"
  }, [_vm._v("резерв")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-around": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "outline": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.fund(_vm.Account.id)
      }
    }
  }, [_vm._v("Пополнить счет")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "outline": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.withdraw(_vm.Account.id)
      }
    }
  }, [_vm._v("Вывести деньги")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Проекты'
      }
    }
  }, [_vm._v("Проекты")])], 1), _vm._v(" "), _c('span', [_vm._v("/"), _c('b', [_vm._v(" Вывод средств ")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('h1', [_vm._v(" Вывод средств ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "my-5": ""
    }
  }, [_c('div', [_vm._v("\n      Вывод средств осуществляется на тот же счет, откуда было пополнение.\n    ")]), _vm._v(" "), _c('div', [_vm._v("\n      Для вывода, необходимо заполнить заявку, после обработки которой, будет осуществлен перевод средств.\n    ")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "justify-start": ""
    }
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Проекты'
      }
    }
  }, [_vm._v("Проекты")])], 1), _vm._v(" "), _c('span', [_vm._v("/"), _c('b', [_vm._v(" Проект ")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "my-2": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12 md9"
  }, [_c('v-card', {
    staticClass: "elevation-1"
  }, [_c('v-card-title', [_c('h2', [_vm._v(_vm._s(_vm.Project.name))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Статус:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.status))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Объем закупки:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.quantity) + " из " + _vm._s(_vm.Project.maxQuantity))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Сумма:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.sum) + " из " + _vm._s(_vm.Project.maxSum))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Плановая дата старта:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.dateStart))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Плановая дата закрытия:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.dateExpected))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Ожидаемая прибыль (%):")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.profitExpected))])], 1), _vm._v(" "), (_vm.Project.my) ? _c('v-list-tile', [_c('h3', [_vm._v("Мои инвестиции")])]) : _vm._e(), _vm._v(" "), (_vm.Project.my) ? _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Инвестированная сумма:")]), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "align-end"
  }, [_vm._v(_vm._s(_vm.Project.sumMy))])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.Project.status == 'открыт') ? _c('v-flex', {
    staticClass: "xs12 md8",
    attrs: {
      "my-4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-1"
  }, [_c('v-card-title', [_c('h4', [_vm._v("Инвестирование")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('h5', [_vm._v("Вы можете инвестировать в этот проект максимально " + _vm._s(_vm.Project.maxSum - _vm.Project.sum) + " руб.")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs-4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "suminput",
    attrs: {
      "label": "Сумма",
      "type": "number",
      "rules": [_vm.rules.required, _vm.rules.positive]
    },
    model: {
      value: (_vm.sum),
      callback: function($$v) {
        _vm.sum = $$v
      },
      expression: "sum"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs-8": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.invest()
      }
    }
  }, [_vm._v("Инвестировать")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 4000,
      "top": true,
      "bottom": false,
      "right": true,
      "left": false,
      "multi-line": false,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Закрыть")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "justify-start": ""
    }
  }, [_c('balancebox'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-5": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("Проекты для инвестиций")])]), _vm._v(" "), _vm._l((_vm.Projects), function(project, index) {
    return _c('v-flex', {
      key: project.id,
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('v-card', {
      staticClass: "elevation-1 cardProject"
    }, [_c('v-card-title', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Проект',
          params: {
            id: project.id
          }
        },
        "text-right": ""
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Объем закупки (т.):")]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "align-end"
    }, [_vm._v(_vm._s(project.quantity) + " из " + _vm._s(project.maxQuantity))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Сумма закупки:")]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "align-end"
    }, [_vm._v(_vm._s(project.sum) + " из " + _vm._s(project.maxSum))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Дата закупки:")]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "align-end"
    }, [_vm._v(_vm._s(project.dateStart))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Ожидаемая прибыль (%):")]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "align-end"
    }, [_vm._v(_vm._s(project.profitExpected))])], 1)], 1), _vm._v(" "), _c('v-card-actions', {
      attrs: {
        "pa-3": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "success"
      },
      on: {
        "click": function($event) {
          return _vm.invest(project.id)
        }
      }
    }, [_vm._v("Инвестировать")])], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("Мои инвестиции")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "elevation-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.myProjects,
      "hide-actions": "",
      "item-key": "name"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.num))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              return _vm.clickProject(props.item)
            }
          }
        }, [_c('a', [_vm._v(_vm._s(props.item.name))])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.sumMy))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.profit))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), (!_vm.ready) ? _c('v-layout', {
    staticClass: "overlay",
    attrs: {
      "row": ""
    }
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Items")]), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return _c('v-list-tile', {
      key: index
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "black"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(item['.key'])
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-container', [_c('v-text-field', {
    attrs: {
      "label": "Item Name"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addItem()
      }
    },
    model: {
      value: (_vm.Item.name),
      callback: function($$v) {
        _vm.$set(_vm.Item, "name", $$v)
      },
      expression: "Item.name"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("Add Item")])], 1)], 1), _vm._v(" "), (!_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_firebase_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__storage_modules_myfirebase_auth_auth__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__storage_modules_projectsstore__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__storage_modules_accountstore__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__storage_modules_myfirebase_storage_storage__ = __webpack_require__(300);







__webpack_require__(437);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var firestore = __WEBPACK_IMPORTED_MODULE_2__src_firebase_firebase__["a" /* firebase */].firestore();
firestore.settings({});

var error = '';

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
    modules: {
        auth: __WEBPACK_IMPORTED_MODULE_3__storage_modules_myfirebase_auth_auth__["a" /* default */],
        storage: __WEBPACK_IMPORTED_MODULE_6__storage_modules_myfirebase_storage_storage__["a" /* default */],
        projects: __WEBPACK_IMPORTED_MODULE_4__storage_modules_projectsstore__["a" /* default */],
        account: __WEBPACK_IMPORTED_MODULE_5__storage_modules_accountstore__["a" /* default */]
    },

    state: {
        firestore: firestore,
        error: error,
        firebase: __WEBPACK_IMPORTED_MODULE_2__src_firebase_firebase__["a" /* firebase */]
    },

    mutations: {},

    getters: {},

    actions: {}
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$store = store;

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Profile = function () {
    function Profile(ref) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Profile);

        this.uid = ref.uid || '';
        this.email = ref.email || '';
        this.displayName = ref.displayName || '';
        this.phone = ref.phone || "";
        this.city = ref.city || "";
        this.role = ref.role || "";
        this.FIO = ref.FIO || "";
        this.passport = ref.passport || "";
        this.address = ref.address || "";
        this.photoURL = ref.photoURL || "";
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Profile, [{
        key: 'toJson',
        value: function toJson() {
            return {
                email: this.email,
                displayName: this.displayName,
                phone: this.phone,
                city: this.city,
                role: this.role,
                FIO: this.FIO,
                passport: this.passport,
                address: this.address,
                photoURL: this.photoURL
            };
        }
    }]);

    return Profile;
}();

/* harmony default export */ __webpack_exports__["a"] = (Profile);

/***/ })

},[290]);


// WEBPACK FOOTER //
// static/js/app.a3dd59a9859c5a023fc6.js